<template>
	<layout-main>
		<template #toolbar>
			<layout-tool-bar />
		</template>

		<v-container class="fill-wh">
			<template v-if="!isTicketView">
				<v-tabs fixed-tabs hide-slider show-arrows background-color="transparent">
					<v-tab v-for="tab in tabs" :key="tab.route" :to="tab.route" v-text="tab.title"></v-tab>
				</v-tabs>
				<v-divider />
			</template>

			<router-view />
		</v-container>
	</layout-main>
</template>

<style lang="scss" scoped>

</style>

<script>
import strings from "@/utils/strings";
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			titles: strings.k4noc.titles,
		};
	},

	computed: {
		...mapGetters({
			tabs: "menu/nocTabs",
		}),

		isTicketView() {
			return !!this.$route.params.ticketId || !!this.$route.params.sysId;
		}
	},

	created() {
		if (!~this.tabs.findIndex(({ route }) => this.$route.path.includes(route)))
			this.$router.replace(this.tabs[0].route);
	}
};
</script>
